import { useMemo } from "react";

import { skipToken } from "@reduxjs/toolkit/query";

import { useGetAvailablePaymentMethodsQuery, useGetCustomerCartIdQuery } from "@jti/store/slices/magentoApiSlice";
import { useGetPaymentMethodsQuery } from "@jti/store/slices/paymentApiSlice";

import { useCartItems } from "@checkout-v2/shared/hooks/useCartItems";

export const useAvailablePaymentMethodsForCart = () => {
  const { data: cartItems, isLoading: isLoadingCart } = useCartItems();
  const { data: cartIdData } = useGetCustomerCartIdQuery();
  const cartId = cartIdData?.customerCart?.id;
  const skus = useMemo(() => (cartItems ?? []).map((item) => item.sku), [cartItems]);

  const evoQueryResult = useGetPaymentMethodsQuery({ skus }, { skip: isLoadingCart || !skus.length });
  const magentoQueryResult = useGetAvailablePaymentMethodsQuery(cartId ?? skipToken);

  const { data: evoMethods, isLoading: isLoadingEvo, isError: isEvoError, error: evoError } = evoQueryResult;
  const {
    data: magentoMethods,
    isLoading: isLoadingMagento,
    isError: isMagentoError,
    error: magentoError,
  } = magentoQueryResult;

  const isLoading = isLoadingCart || isLoadingEvo || isLoadingMagento;
  const isError = isEvoError || isMagentoError;
  const error = evoError || magentoError;

  return {
    evoMethods,
    magentoMethods,
    isLoading,
    isError,
    error,
    evoQueryState: evoQueryResult,
    magentoQueryState: magentoQueryResult,
  };
};
